import { NgModule } from '@angular/core';
import { ExpansionDirective } from './expansion.directive';

@NgModule({
  declarations: [ExpansionDirective],
  exports: [ExpansionDirective],
})
export class ExpansionModule {}
